/** Proposte: classificazioni, collegamenti claim-red flag, nuove voci di lista. */
import type { Forma } from "../forma";

export const it = {
  titoloAdmin: "Proposte da approvare",
  titoloMie: "Le mie proposte",
  sottotitolo: "Classificazioni, collegamenti claim-red flag e nuove voci di lista: chiunque propone, l'admin approva, modifica o rifiuta.",
  approvaSelezionate: "Approva le selezionate ({{n}})",
  tabDaApprovare: "Da approvare",
  tabApprovate: "Approvate",
  tabRifiutate: "Rifiutate",
  tuttiTipi: "Tutti i tipi",
  daChiunque: "Proposte da chiunque",
  daImport: "Import",
  daPersone: "Persone",
  proposta: "Proposta",
  tipo: "Tipo",
  oggetto: "Oggetto",
  cosa: "Cosa propone",
  da: "Da",
  quando: "Quando",
  esito: "Esito",
  decisaDa: "{{chi}}, {{quando}}",
  approva: "Approva",
  modifica: "Modifica",
  rifiuta: "Rifiuta",
  notaDecisione: "Nota (facoltativa)",
  rifiutaTitolo: "Rifiuta la proposta {{codice}}",
  modificaTitolo: "Modifica e approva {{codice}}",
  approvate: "{{n}} proposte approvate",
  ncAperte: "NC aperte: {{codici}}",
  errori: "{{n}} non approvate: {{dettaglio}}",
  vuoto: "Nessuna proposta",
  lista: "Lista",
  valore: "Valore",
  segnalazione: "Segnalazione",
  claim: "Claim",
  nuovaVoce: "Proponi una nuova voce di lista",
  nuovaVoceInviata: "Proposta inviata all'admin",
};

export const en: Forma<typeof it> = {
  titoloAdmin: "Proposals to approve",
  titoloMie: "My proposals",
  sottotitolo: "Classifications, claim-red flag links and new list items: anyone proposes, the admin approves, changes or rejects.",
  approvaSelezionate: "Approve selected ({{n}})",
  tabDaApprovare: "To approve",
  tabApprovate: "Approved",
  tabRifiutate: "Rejected",
  tuttiTipi: "All types",
  daChiunque: "Proposals by anyone",
  daImport: "Import",
  daPersone: "People",
  proposta: "Proposal",
  tipo: "Type",
  oggetto: "Subject",
  cosa: "What it proposes",
  da: "By",
  quando: "When",
  esito: "Outcome",
  decisaDa: "{{chi}}, {{quando}}",
  approva: "Approve",
  modifica: "Change",
  rifiuta: "Reject",
  notaDecisione: "Note (optional)",
  rifiutaTitolo: "Reject proposal {{codice}}",
  modificaTitolo: "Change and approve {{codice}}",
  approvate: "{{n}} proposals approved",
  ncAperte: "NCs opened: {{codici}}",
  errori: "{{n}} not approved: {{dettaglio}}",
  vuoto: "No proposals",
  lista: "List",
  valore: "Value",
  segnalazione: "Report",
  claim: "Claim",
  nuovaVoce: "Propose a new list item",
  nuovaVoceInviata: "Proposal sent to the admin",
};
